import type { Security } from '../types/Security';
import type { SyntheticProductTypeEnum } from '../types/types';
import { getGroup, type ProductGroup } from './security';

export const RECENT_SYMBOLS_PER_PRODUCT_MAX = 5;

export function getRecentSymbolsListKeyForSecurity(security: Security): string {
  const group = getGroup(security);
  if (group === 'Multi') {
    const syntheticType = security.MultilegDetails?.SyntheticProductType;
    return syntheticType != null ? `Multi:${syntheticType}` : 'Multi';
  }
  return group;
}

export function getOrderFormRecentSymbolListKey(
  productGroup: ProductGroup,
  multilegSyntheticType: SyntheticProductTypeEnum | undefined
): string {
  if (productGroup === 'Multi') {
    return multilegSyntheticType != null ? `Multi:${multilegSyntheticType}` : 'Multi';
  }
  return productGroup;
}
